export { SkeletonBlock } from './SkeletonBlock';
export type { SkeletonBlockProps, SkeletonBlockVariant } from './SkeletonBlock.types';
